import { mediaQueries } from "../data";
import { pxToRem } from "./pxToRem";

export function responsiveFontSizes({
  lg,
  md,
  sm,
}: {
  lg: number;
  md: number;
  sm: number;
}) {
  return {
    [mediaQueries.upLg]: { fontSize: pxToRem(lg) },
    [mediaQueries.upMd]: { fontSize: pxToRem(md) },
    [mediaQueries.upSm]: { fontSize: pxToRem(sm) },
  };
}
